import * as React from 'react';

type Props = {};

const NotFoundPage: React.FC<Props> = () => {
	return <>Страница не найдена</>;
};

export default NotFoundPage;
